module.exports = __webpack_public_path__ + "img/gntech_gallery9.07d44327.jpg";